(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.controller('AppStoreV2Controller', ["$scope", "$route", "path", "licenseOptions", "modulePropsToOptions", "utilityDao", "sideMenuManager", "modals", "appConfigurator", "appOperationHelper", "authorizationLinkHelper", "modulesDao", "troubleshooting", "feature", "dualAppHelper", "wizardHelper", "$q", "$timeout", "brandInfo", "appStoreHelper", function ($scope, $route, path, licenseOptions, modulePropsToOptions, utilityDao, sideMenuManager, modals, appConfigurator, appOperationHelper, authorizationLinkHelper, modulesDao, troubleshooting, feature, dualAppHelper, wizardHelper, $q, $timeout, brandInfo, appStoreHelper) {
        var catsFilter, opButtonAsIcon, activeGroups, lockActionsCount = 0;
        var newCloudApps = [
            'o365_onedrive',
            'o365_sharepoint',
            'slack',
            'sharefile',
            'ms_teams',
            'dropbox2',
            'box2',
            'o365_job',
            'gdrive'
        ];
        $scope.userRole = sideMenuManager.currentUser().role;
        if ($route.current.accessor === 'cloudApps') {
            catsFilter = { family: 'saas' };
            opButtonAsIcon = false;
            activeGroups = true;
            $scope.pageSaas = true;
        } else {
            catsFilter = { family: 'security' };
            opButtonAsIcon = true;
            activeGroups = false;
            if (feature.checkpointTheme) {
                $route.current.title = 'Services';
            }
        }
        var imgPath = path('app-store');
        var img2Path = path('gui-v2');
        var img2Prefix = 'apps-logos/';
        var stateWeight = {
            active: 0,
            enabled: 0,
            nonactive: 1,
            disabled: 1,
            display_only: 2
        };
        var whiteListSecTools = [
            'dlp_gtb',
            'ap_avanan',
            'lastline_av_file',
            'lastline_av_hash',
            'microsoft_encryption',
            'clicktime_protection',
            'anomaly_detection',
            'syslog',
            'office365_atp'
        ];
        var blackListSecTools = [];
        if (feature.mspSecurityEvents) {
            blackListSecTools.push('splunk');
        }
        function isWhiteListSecTools(app) {
            if (troubleshooting.entityDebugEnabled()) {
                return true;
            } else if (app.is_saas || !feature.avananTheme) {
                return true;
            } else if (feature.avananTheme && _(whiteListSecTools).indexOf(app.name) !== -1 && app.state === 'active') {
                return true;
            }
            return false;
        }
        function isBlackListSecTools(app) {
            if (troubleshooting.entityDebugEnabled()) {
                return false;
            } else if (feature.avananTheme && !app.is_saas && (_(blackListSecTools).indexOf(app.name) !== -1 || app.state !== 'active')) {
                return true;
            }
            return false;
        }
        function isHideOpBtn() {
            if (!opButtonAsIcon) {
                return false;
            } else if (troubleshooting.entityDebugEnabled()) {
                return false;
            } else if (!feature.avananTheme) {
                return false;
            }
            return true;
        }
        function loadData(currentStatus) {
            return modulesDao.getModules(true).then(function (response) {
                var categoriesMap = {};
                var topCategoriesMap = {};
                lockActionsCount = 0;
                if (response.data.apps_items && response.data.apps_items.modules.length > 0) {
                    var modules = _(response.data.apps_items.modules).filter(function (item) {
                        return !newCloudApps.includes(item.name.toLowerCase());
                    });
                    response.data.apps_items.modules = modules;
                }
                $scope.topCategories = _(response.data.topCategories).chain().map(function (cat) {
                    topCategoriesMap[cat.name] = cat;
                    cat.categories = [];
                    return cat;
                }).sortBy('order').value();
                topCategoriesMap.noTop = {
                    label: '',
                    name: 'noTop',
                    categories: []
                };
                $scope.topCategories.push(topCategoriesMap.noTop);
                $scope.categories = _(response.data.apps_categories.categories).chain().filter(function (cat) {
                    if (feature.lastlineTheme && cat.type === 'dlp') {
                        return false;
                    }
                    if (catsFilter.family && cat.family !== catsFilter.family) {
                        return false;
                    }
                    categoriesMap[cat.categoryId] = cat;
                    cat.activeApps = [];
                    cat.inactiveApps = [];
                    cat.allApps = [];
                    if (activeGroups) {
                        cat.groups = [
                            {
                                title: 'Active ',
                                apps: cat.activeApps
                            },
                            {
                                title: 'Inactive ',
                                apps: cat.inactiveApps
                            }
                        ];
                    } else {
                        cat.groups = [{
                                title: '',
                                apps: cat.allApps,
                                activeApps: cat.activeApps
                            }];
                    }
                    return true;
                }).sortBy(function (cat) {
                    return parseInt(cat.appStoreOrder);
                }).each(function (cat) {
                    (topCategoriesMap[cat.topCategory || 'noTop'] || topCategoriesMap.noTop).categories.push(cat);
                }).value();
                _(response.data.apps_items.modules).chain().filter(function (app) {
                    return !isBlackListSecTools(app) && categoriesMap[app.category_id] && !app.hidden && (!app.gui_hidden || troubleshooting.entityDebugEnabled());
                }).sortBy(function (app) {
                    return parseInt(app.app_store_order);
                }).sortBy(function (app) {
                    if (app.options && app.options.license === 'contact_support') {
                        return 6;
                    }
                    if (!app.license_info) {
                        return 5;
                    }
                    if (app.license_info.license_type === 'paid') {
                        if (app.isExpired) {
                            return 2;
                        }
                        return 1;
                    }
                    if (app.license_info.license_type === 'demo') {
                        if (app.isExpired) {
                            return 4;
                        }
                        return 3;
                    }
                    return 5;
                }).sortBy(function (app) {
                    return stateWeight[app.state];
                }).each(function (app) {
                    var cat = categoriesMap[app.category_id];
                    app.autoId = 'app_store_' + app.name;
                    app.category = cat;
                    if (app.app_store2_logo) {
                        app.imgSrc = img2Path.imgRel(img2Prefix + app.app_store2_logo);
                    } else {
                        app.imgSrc = imgPath.imgRel(app.app_store_icon);
                    }
                    app.UIoptions = modulePropsToOptions(app, { licenseButton: {} }, true);
                    setAppButtons(app);
                    cat.allApps.push(app);
                    if (app.state === 'active') {
                        cat.activeApps.push(app);
                    } else {
                        cat.inactiveApps.push(app);
                    }
                    if (app.lock_actions) {
                        lockActionsCount++;
                    }
                });
                $scope.topCategories = _($scope.topCategories).filter(function (topCat) {
                    topCat.categories = _(topCat.categories).filter(function (cat) {
                        return _(cat.groups).find(function (group) {
                            return group.apps.length;
                        });
                    });
                    return topCat.categories.length;
                });
                if (currentStatus) {
                    var appsPrefix = 'inactive';
                    if (currentStatus.mode === 'reauth') {
                        appsPrefix = 'active';
                    }
                    var currentIndex = _($scope.categories[0][appsPrefix + 'Apps']).findIndex(function (app) {
                        return currentStatus.currentSaaS === app.module_name;
                    });
                    if (currentIndex !== -1) {
                        var currentApp = $scope.categories[0][appsPrefix + 'Apps'][currentIndex];
                        if (currentStatus.currentStep) {
                            currentApp.UIoptions.currentStep = currentStatus.currentStep;
                            currentApp.UIoptions.mode = currentStatus.mode;
                            dualAppHelper.dualAppWizard(currentApp.UIoptions);
                        } else if (currentStatus.dualAppStatus === 'done') {
                            if (currentStatus.currentSaaS !== 'google_mail') {
                                window.localStorage.removeItem('dualAuthStarted');
                            }
                            executeDualOperation(currentApp);
                        }
                    }
                }
                if (lockActionsCount) {
                    $timeout(function () {
                        console.log('Reloading due to lock_actions...');
                        loadData();
                    }, 10000);
                } else {
                    var appNameInProgress = appOperationHelper.appInProgress();
                    if (appNameInProgress !== '') {
                        appOperationHelper.operationEnd(appNameInProgress, true);
                    }
                }
            });
        }
        function setAppButtons(app) {
            app.buttons = [];
            if (app.state === 'display_only') {
                app.buttons.push({
                    autoId: 'app_store_' + app.name + '_btn_notify_me',
                    label: 'Notify Me When Available',
                    execute: function () {
                        return notifyWhenAvailable(app);
                    }
                });
                return;
            }
            var contactSupportLabel = 'Contact Support';
            if (feature.checkpointTheme) {
                contactSupportLabel = 'Register for Early Availability';
            } else if (feature.sonicwallTheme) {
                contactSupportLabel = 'Coming Soon';
            }
            if (app.license === 'contact_support') {
                app.buttons.push({
                    autoId: 'app_store_' + app.name + '_btn_contact_support',
                    label: contactSupportLabel,
                    execute: function () {
                        return licenseOptions.contactSupportDialog(app.UIoptions);
                    }
                });
                return;
            }
            if (!app.hideConfigureButton && (!app.hideConfigureLicenseButtons || $route.current.accessor === 'cloudApps') && appConfigurator.configAvailable(app.UIoptions)) {
                app.buttons.push({
                    autoId: 'app_store_' + app.name + '_btn_config',
                    name: 'config',
                    label: 'Configure',
                    execute: function () {
                        return configure(app);
                    }
                });
            }
            if (!app.hideLicenseButton && !app.hideConfigureLicenseButtons && opButtonAsIcon) {
                var licenseButton = licenseOptions.button(app.UIoptions, loadData);
                if (licenseButton.enabled) {
                    app.buttons.push({
                        autoId: 'app_store_' + app.name + '_btn_license',
                        inProgress: function () {
                            return appOperationHelper.operationInProgress(app.name);
                        },
                        label: 'License',
                        execute: function () {
                            if (appOperationHelper.operationInProgress(app.name)) {
                                return;
                            }
                            licenseButton.execute();
                        },
                        btnClass: 'op-btn'
                    });
                }
            }
            var operation = getOperation(app);
            if (operation === 'hide') {
                return;
            }
            var label = (operations[operation] || operations.default).label || operation;
            app.opButton = {
                autoId: 'app_store_' + app.name + '_btn_' + label.toLowerCase(),
                inProgress: function () {
                    return appOperationHelper.operationInProgress(app.name);
                },
                label: label,
                btnClass: 'op-btn op-' + operation,
                enabled: false,
                hide: false,
                iconClass: (operations[operation] || operations.default).iconClass || '',
                asIcon: opButtonAsIcon,
                reauth: function () {
                    app.UIoptions.currentStep = 0;
                    app.UIoptions.mode = 'reauth';
                    dualAppHelper.dualAppWizard(app.UIoptions);
                },
                execute: function () {
                    if (app.opButton.inProgress()) {
                        return;
                    }
                    if (label === 'Start') {
                        var checkModule = dualAppHelper.checkDualApp(app.module_name);
                        if (checkModule.isDualApp) {
                            if (checkModule.authName === 'office365') {
                                return dualAppHelper.checkActiveStatusO365().then(function (r) {
                                    return dualAppHelper.authenticationStatus(checkModule.authName, app.module_name, r.data).then(function (response) {
                                        if (response.data.hasOwnProperty('step')) {
                                            app.UIoptions.currentStep = response.data.step;
                                            if (response.data.step === -1 && checkModule.authName === 'office365') {
                                                var linkForAutoMode = path('common').staticFile('AvananO365-ManualCreationOfMailConfigs.pdf');
                                                var linkForManualMode = path('common').staticFile('AvananO365-ManualCreationOfMailConfigs.pdf');
                                                var modeSelectorTitle = 'Office365 Install Mode';
                                                if (feature.checkpointTheme) {
                                                    linkForAutoMode.path = 'https://supportcenter.checkpoint.com/supportcenter/portal?eventSubmit_doGoviewsolutiondetails=&solutionid=sk144213';
                                                    linkForManualMode.path = 'https://sc1.checkpoint.com/documents/CloudGuard_SaaS_ManualConfiguration/html_frameset.htm';
                                                    modeSelectorTitle = 'Office 365 Configuration Mode';
                                                } else if (feature.sonicwallTheme) {
                                                    linkForAutoMode = path('common').staticFile('CAS_SaaS_Manually_Configuring_Office365.pdf');
                                                    linkForManualMode = path('common').staticFile('CAS_SaaS_Manually_Configuring_Office365.pdf');
                                                }
                                                var textForAutoMode = '<strong>Automatic Mode</strong>: In this mode all Office 365 will be performed automatically. ' + 'The following <a class="manual-mailflow-doc" target="_blank" href="' + linkForAutoMode.path + '"><strong>Link</strong></a> described the configurations applied to Office 365';
                                                var textForManualMode = '<strong>Manual Mode</strong>: In this mode the system will not apply any changes to Office 365 and you will need to apply the configuration changes manually, ' + 'during the install and when the policy changes. The following <a class="manual-mailflow-doc" target="_blank" href="' + linkForManualMode.path + '"><strong>Link</strong></a> described the required configuration changes';
                                                if (feature.checkpointTheme) {
                                                    textForAutoMode = '<strong>Automatic Mode</strong><br>' + '<p class="manual-mailflow-mode">CloudGuard SaaS automatically configures your Office 365 account.<br>' + 'Click <a class="manual-mailflow-doc" target="_blank" href="' + linkForAutoMode.path + '">' + '<strong>here</strong></a> for more details.</p>' + '<p class="manual-mailflow-mode highlight">Important \u2013 a Global Admin Account will be created in your Exchange Admin Center. If you have multi-factor enabled by default on Global Admin accounts, ' + 'please contact <a class="manual-mailflow-doc" target="_blank" href="https://www.checkpoint.com/support-services/contact-support/">' + '<strong>Check Point Support</strong></a> or select Manual Mode.</p>';
                                                    textForManualMode = '<strong>Manual Mode</strong><br>' + '<p class="manual-mailflow-mode">You must manually configure your Office 365 account to work with CloudGuard SaaS. ' + 'Additional manual configuration will be necessary for policy changes. Click ' + '<a class="manual-mailflow-doc" target="_blank" href="' + linkForManualMode.path + '"><strong>here</strong></a> ' + 'for detailed instructions on how to manually configure Office 365. (Your portal name is: <strong>' + brandInfo.customerSubdomain() + '</strong>).</p>';
                                                }
                                                var modeParams = [{
                                                        id: 'config_mode_for_office365',
                                                        type: 'radio-group',
                                                        buttons: [
                                                            {
                                                                label: '#' + JSON.stringify({
                                                                    text: textForAutoMode,
                                                                    display: 'html'
                                                                }),
                                                                value: 'automatic'
                                                            },
                                                            {
                                                                label: '#' + JSON.stringify({
                                                                    text: textForManualMode,
                                                                    display: 'html'
                                                                }),
                                                                value: 'manual'
                                                            }
                                                        ],
                                                        data: 'automatic',
                                                        paramClass: 'full-width-param o365-config-mode'
                                                    }];
                                                return modals.params([{
                                                        lastPage: true,
                                                        params: modeParams
                                                    }], modeSelectorTitle, 'md').then(function (data) {
                                                    var newObj = { manual_mailflow_config: false };
                                                    if (data.config_mode_for_office365 === 'manual') {
                                                        newObj.manual_mailflow_config = true;
                                                    }
                                                    return modulesDao.saveConfig('office365_auth', newObj).then(function () {
                                                        dualAppHelper.dualAppWizard(app.UIoptions);
                                                    }, function () {
                                                        dualAppHelper.dualAppWizard(app.UIoptions);
                                                    });
                                                });
                                            }
                                            dualAppHelper.dualAppWizard(app.UIoptions);
                                        } else if (response.data.hasOwnProperty('done')) {
                                            executeDualOperation(app);
                                        }
                                    });
                                });
                            }
                            return dualAppHelper.authenticationStatus(checkModule.authName, app.module_name).then(function (response) {
                                if (response.data.hasOwnProperty('step')) {
                                    app.UIoptions.currentStep = response.data.step;
                                    dualAppHelper.dualAppWizard(app.UIoptions);
                                } else if (response.data.hasOwnProperty('done')) {
                                    executeDualOperation(app);
                                }
                            });
                        }
                    } else if (label === 'Stop' && app.module_name && app.module_name.indexOf('office365') !== -1) {
                        return modals.confirm({
                            title: 'Are you sure?',
                            message: 'When disabling this engine a cleanup operation will be initiated. A cooldown period of 30 minutes is required before the engine can be restarted',
                            okText: 'OK',
                            cancelText: 'Cancel'
                        }).then(function () {
                            return modulesDao.retrieveConfig('office365_auth').then(function (res) {
                                if (res.data.manual_mailflow_config && res.data.manual_mailflow_config.value === true) {
                                    return modals.confirm({
                                        title: 'Warning',
                                        message: 'Note that the system will not automatically delete the changes applied to Office 365 and you will need to delete these changes manually',
                                        okText: 'OK',
                                        cancelText: 'Cancel'
                                    }).then(function () {
                                        return executeOperation(app);
                                    });
                                }
                                return executeOperation(app);
                            }, function () {
                                return executeOperation(app);
                            });
                        });
                    } else if (label === 'Stop' && app.module_name && app.module_name.indexOf('google') !== -1) {
                        return modals.confirm({
                            title: 'Are you sure?',
                            message: 'When disabling this engine a cleanup operation will be initiated. A cooldown period of 30 minutes is required before the engine can be restarted',
                            okText: 'OK',
                            cancelText: 'Cancel'
                        }).then(function () {
                            return executeOperation(app);
                        });
                    }
                    if (label === 'Start' && app.module_name === 'sharefile') {
                        return appStoreHelper.shareFileAlert().then(function () {
                            executeOperation(app);
                        });
                    }
                    return executeOperation(app);
                },
                statusTip: app.lock_actions ? 'Stopping...this might take a few minutes' : undefined
            };
            // hide STOP button for clicktime_protection for Sonicwall since the operation caused a bug.
            if (app.name === 'clicktime_protection' && app.options && app.options.operation === 'stop' && feature.sonicwallTheme) {
                app.opButton.hide = true;
            }
            if (!opButtonAsIcon) {
                app.buttons.push(app.opButton);
            }
            // TODO: Remove this code after all customers have moved to the new apps.
            if (app.name == 'office365_sharepoint' && localStorage.getItem('trigger_office365_emails_reauthorize')) {
                app.opButton.reauth();
                localStorage.removeItem('trigger_office365_emails_reauthorize');
            }
        }
        var configDialogShown = false;
        function configure(app) {
            if (configDialogShown) {
                return;
            }
            configDialogShown = true;
            return appConfigurator.configure(app.UIoptions, undefined, undefined, undefined, true).then(function () {
                loadData();
            }).finally(function () {
                configDialogShown = false;
            });
        }
        $scope.$on('configure-app', function (event, args) {
            var foundApp;
            _($scope.categories).find(function (cat) {
                return _(cat.groups).find(function (group) {
                    return _(group.apps).find(function (app) {
                        if (app.name === args.app) {
                            foundApp = app;
                        }
                    });
                });
            });
            if (foundApp) {
                configure(foundApp);
            }
        });
        function notifyWhenAvailable(app) {
            var msg = '';
            var subject = 'Request to notify when \'coming soon\' app is available';
            msg += '<p>This is automatically generated message.<br />User pressed \'Notify me when available\' button</p>';
            msg += '<table boder="0">';
            msg += '<tr><td>Application name</td><td>' + app.name + '</td></tr>';
            msg += '<tr><td>Application title</td><td>' + app.label + '</td></tr>';
            msg += '<tr><td>Domain</td><td>' + window.location.host + '</td></tr>';
            msg += '<tr><td>User</td><td>' + sideMenuManager.currentUser().email + '</td></tr>';
            msg += '<tr><td>Full page url</td><td>' + window.location.href + '</td></tr>';
            msg += '</table>';
            utilityDao.sendSupportMessage({
                subject: subject,
                body: msg
            }).then(function () {
                modals.alert('This application is coming soon! We will notify you when it becomes available.', { title: ' ' });
            });
        }
        function getOperation(app) {
            if (!app.options || !app.name || !app.options.operation || app.options.operation === 'none') {
                return 'hide';
            } else {
                return app.options.operation;
            }
        }
        function executeOperation(app) {
            if (app.is_saas && !app.saas_authorized && app.options.operation === 'start' && appConfigurator.showConfigurationLink(app.UIoptions)) {
                if (feature.enableSingleAuth && app.module_name.indexOf('office365') !== -1) {
                    dualAppHelper.o365AlertTextModal().then(function () {
                        authorizationLinkHelper.openLink(app.UIoptions);
                    });
                } else {
                    authorizationLinkHelper.openLink(app.UIoptions);
                }
                return;
            }
            var pages = [{
                    lastPage: true,
                    okButton: app.opButton.label,
                    params: [{
                            type: 'message',
                            message: '#' + JSON.stringify({
                                display: 'text',
                                text: 'Are you sure you want to ' + app.opButton.label + ' ' + app.label + '?'
                            }),
                            paramClass: 'full-width-param'
                        }]
                }];
            function refresh() {
                if (app.options.operation === 'stop') {
                    modals.alert('Processing... This may take several minutes.', { title: ' ' });
                }
                return loadData().then(function () {
                    if (app.options.operation !== 'stop') {
                        appOperationHelper.operationEnd(app.name);
                    }
                });
            }
            modals.params(pages, app.opButton.label + ' ' + app.label).then(function (params) {
                if (app.options.operation === 'start') {
                    $.extend(params, { start_matrix_policy: true });
                }
                appOperationHelper.operationStart(app.name, app.options.operation === 'stop');
                return modulesDao.operation(app.name, app.options.operation, params).then(refresh, refresh);
            });
        }
        function executeDualOperation(app) {
            var paramsForDual = {};
            function refresh() {
                if (app.options.operation === 'stop') {
                    modals.alert('Processing... This may take several minutes.', { title: ' ' });
                }
                return loadData().then(function () {
                    if (app.options.operation !== 'stop') {
                        appOperationHelper.operationEnd(app.name);
                    }
                    if (app.options.operation === 'start' && app.name === 'google_drive') {
                        dualAppHelper.checkGSuiteAuthSuccess();
                    }
                });
            }
            if (app.options.operation === 'start') {
                paramsForDual.start_matrix_policy = true;
            }
            appOperationHelper.operationStart(app.name, app.options.operation === 'stop');
            return modulesDao.operation(app.name, app.options.operation, paramsForDual).then(refresh, refresh);
        }
        var operations = {
            'start': {
                iconClass: 'fa-play',
                label: 'Start'
            },
            'stop': {
                iconClass: 'fa-pause',
                label: 'Stop'
            },
            'default': { iconClass: 'fa-question' }
        };
        $scope.$on('saas-authorized', function () {
            loadData();
        });
        function checkingDualAppStatus() {
            try {
                var dualAuthStarted = JSON.parse(window.localStorage.getItem('dualAuthStarted'));
                if (dualAuthStarted && dualAuthStarted.saas) {
                    var checkSaaS = dualAppHelper.checkDualApp(dualAuthStarted.saas);
                    if (checkSaaS.isDualApp) {
                        return dualAppHelper.authenticationStatus(checkSaaS.authName, dualAuthStarted.saas, dualAuthStarted.mode).then(function (response) {
                            if (response.data.hasOwnProperty('step') && response.data.step === 1) {
                                loadData({
                                    currentStep: response.data.step,
                                    currentSaaS: dualAuthStarted.saas,
                                    dualAppStatus: 'inProgress',
                                    mode: dualAuthStarted.mode || 'normal'
                                });
                            } else if (response.data.hasOwnProperty('done')) {
                                loadData({
                                    currentSaaS: dualAuthStarted.saas,
                                    dualAppStatus: 'done'
                                });
                            } else {
                                loadData();
                            }
                        });
                    }
                }
            } catch (e) {
                console.log('--error on app-store-v2 checkingDualAppStatus---', e);
            }
            loadData();
        }
        checkingDualAppStatus();
        function checkingDualAppStatusForCloudInfra() {
            try {
                var dualAuthStarted = JSON.parse(window.localStorage.getItem('dualAuthStarted'));
                if (dualAuthStarted && dualAuthStarted.saas) {
                    var checkSaaS = dualAppHelper.checkDualApp(dualAuthStarted.saas);
                    if (checkSaaS.isDualApp) {
                        return dualAppHelper.authenticationStatus(checkSaaS.authName, dualAuthStarted.saas, dualAuthStarted.mode).then(function (response) {
                            if (response.data.hasOwnProperty('step') && response.data.step === 1) {
                                return {
                                    currentStep: response.data.step,
                                    currentSaaS: dualAuthStarted.saas,
                                    dualAppStatus: 'inProgress'
                                };
                            } else if (response.data.hasOwnProperty('done')) {
                                return {
                                    authName: checkSaaS.authName,
                                    currentSaaS: dualAuthStarted.saas,
                                    dualAppStatus: 'done'
                                };
                            } else {
                                return null;
                            }
                        });
                    }
                }
            } catch (e) {
                console.log('--error on app-store-v2 checkingDualAppStatusForCloudInfra---', e);
            }
            return null;
        }
        function dualAuthTriggerForCloudInfra(currentStep) {
            var p = $q.when();
            return p.then(function () {
                return checkingDualAppStatusForCloudInfra();
            }).then(function (status) {
                if (status && (currentStep === 0 && status.currentStep === 1 || currentStep === 0 && status.dualAppStatus === 'done' && status.authName === 'gsuite' || currentStep === 1 && status.dualAppStatus === 'done')) {
                    loadData(status);
                } else {
                    $timeout(function () {
                        dualAuthTriggerForCloudInfra(currentStep);
                    }, 1000);
                }
            });
        }
        // group filter popup check
        var selectGroupsStage = window.localStorage.getItem('selectGroupsStage');
        if (selectGroupsStage) {
            modulesDao.displayUserGroupsFilterModal(selectGroupsStage);
        }
        $scope.$on('dual-auth-started-1', function () {
            dualAuthTriggerForCloudInfra(0);
        });
        $scope.$on('dual-auth-started-2', function () {
            dualAuthTriggerForCloudInfra(1);
        });
        $scope.$on('reauth-office365_emails', function (event, data) {
            dualAppHelper.authenticationStatus('office365', 'office365_emails', 'reauth').then(function (response) {
                if (feature.enableSingleAuth) {
                    if (appStoreHelper.isO365(data.args && data.args.moduleName)) {
                        return dualAppHelper.o365OnboardingAlertModal().then(function () {
                            dualAppHelper.o365ResetReauth();
                        });
                    }
                } else {
                    if (response.data.hasOwnProperty('step')) {
                        data.args.currentStep = response.data.step;
                        data.args.mode = 'reauth';
                        dualAppHelper.dualAppWizard(data.args);
                    } else if (response.data.hasOwnProperty('done')) {
                        data.args.currentStep = 0;
                        data.args.mode = 'reauth';
                        dualAppHelper.dualAppWizard(data.args);
                    }
                }
            });
        });
    }]);
}());